var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "approve",
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "check_circle_FILL0_wght400_GRAD0_opsz48",
    d: "M88.655,190.393l7.183-7-1.168-1.113-6.015,5.861-3.046-2.968-1.142,1.113Zm1.5,5.391A10.047,10.047,0,0,1,86.218,195a10.316,10.316,0,0,1-3.236-2.127,10.024,10.024,0,0,1-2.183-3.153,9.648,9.648,0,0,1,0-7.691,9.877,9.877,0,0,1,2.183-3.141,10.428,10.428,0,0,1,3.236-2.114,10.387,10.387,0,0,1,7.893,0,10.271,10.271,0,0,1,3.223,2.114,9.979,9.979,0,0,1,2.17,3.141,9.648,9.648,0,0,1,0,7.691,10.16,10.16,0,0,1-9.353,6.059Zm0-1.484a8.415,8.415,0,0,0,6.117-2.461,8.31,8.31,0,0,0,0-11.907,8.85,8.85,0,0,0-12.221,0,8.281,8.281,0,0,0,0,11.907A8.428,8.428,0,0,0,90.152,194.3ZM90.152,185.892Z",
    transform: "translate(-80 -176)",
    fill: "#70c38d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.917512c89d9ad170b9e69ad335d6b95e.svg";
export { ForwardRef as ReactComponent };